import React, { useEffect, useRef } from 'react'
import useIntersectionObserver from '../../common/hooks/useIntersectionObserver'

import './index.less'

export default (props) => {
  const { children, onLoad, observerParams = {}, stop = false, loading } = props
  const $load = useRef()
  const entry = useIntersectionObserver($load, observerParams)

  useEffect(() => {
    if (loading) { return }
    if (!!entry?.isIntersecting && !stop) {
      onLoad && onLoad()
    }
  }, [entry, loading])

  return <div className="meinian-load-more-wrap" ref={$load}>{children}</div>
}
